import script from "./Phone.vue?vue&type=script&setup=true&lang=js"
export * from "./Phone.vue?vue&type=script&setup=true&lang=js"

import "./Phone.vue?vue&type=style&index=0&id=38fc86b2&lang=css"

const __exports__ = script;

export default __exports__